module.exports = __webpack_public_path__ + "img/knu_gallery12.dae558b9.jpg";